export default {
	vehiclecheck : {		
		1 : "The Issue has been Fixed",		
		2 : "This issue has been reported to the relevant department",		
		3 : "Clear warning without addressing",		
	},
	assetcheck : {		
		1 : "The Issue has been Fixed",		
		2 : "This issue has been reported to the relevant department",		
		3 : "Clear warning without addressing",			
		4 : "Repair booked with Garage",		
	},
	document : {		
		1 : "Clear document from upcoming and expired tasks list",				
	},
	vehicle_mot_due : {		
		1 : "An MOT for this vehicle has been booked",		
		2 : "This vehicle has been MOT'd",		
		3 : "I do not wish to MOT this vehicle",		
	},
	vehicle_mot_appointment : {		
		1 : "This Vehicle has been MOT'd",		
		2 : "Add Re-test Appointment",		
		3 : "I do not wish to MOT this vehicle",		
	},
	vehicle_tax_due : {		
		1 : "Auto renew 1 year from the first of the month",		
		2 : "Tax Renew Date Updated",		
		3 : "Mark as Sorn",		
	},
	vehicle_insurance_expire : {		
		1 : "Auto renew 1 year from the first of the month",		
		2 : "Insurance Renew Date Updated",		
	},
	vehicle_service_due : {		
		1 : "A service for this vehicle has been booked",		
		2 : "This Vehicle has been serviced",		
		3 : "I do not wish to service this vehicle",		
	},
	vehicle_service_appointment : {		
		1 : "This vehicle has been serviced",		
		2 : "Clear without adding service record",		
	},

	driver_license : {		
		1 : "Driver has renewed Licence",				
	},
	driver_cpc : {		
		1 : "Driver has renewed CPC",				
	},
	driver_adr : {		
		1 : "Driver has renewed ADR",				
	},
}	